import axios from "../config/axios"


export const ApiKeyRepository = {
  // admin only
  getAll: () => {
    return axios.get(`/api/api-key/all`);
  },
  // keys the current user owns plus the keys of their organizations
  getMyKeys: () => {
    return axios.get(`/api/api-key/my`);
  },
  // the response contains the full key
  create: (apiKey) => {
    return axios.post(`/api/api-key`, apiKey);
  },
  reveal: (id) => {
    return axios.post(`/api/api-key/${id}/reveal`);
  },
  // only validUntil can be changed
  edit: (id, validUntil) => {
    return axios.put(`/api/api-key/${id}`, {validUntil});
  },
  delete: (id) => {
    return axios.delete(`/api/api-key/${id}`);
  },
}
